import { render } from "./innerHeaderDiy.vue?vue&type=template&id=971cc63c&scoped=true"
import script from "./innerHeaderDiy.vue?vue&type=script&lang=js"
export * from "./innerHeaderDiy.vue?vue&type=script&lang=js"

import "./innerHeaderDiy.vue?vue&type=style&index=0&id=971cc63c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971cc63c"]])

export default __exports__